import React from "react";
import { SubList } from "./_forms";

export default function Leaves({ staff }) {
  const staffName = (id) => staff.find((x) => x.id === id)?.full_name || id;
  return (
    <SubList
      endpoint="/hr/leaves" dataKey="items"
      lookups={{ staff_id: staffName }}
      columns={[
        ["staff_id", "Employee", true], ["leave_type", "Type"],
        ["start_date", "From", "date"], ["end_date", "To", "date"],
        ["status", "Status", "badge"],
      ]}
      form={[
        { k: "staff_id", label: "Employee", type: "select", options: staff.map((s) => [s.id, `${s.full_name} (${s.employee_code || "—"})`]), required: true },
        { k: "leave_type", label: "Type", type: "select", required: true, options: [
          ["annual", "Annual"], ["sick", "Sick"], ["unpaid", "Unpaid"],
          ["emergency", "Emergency"], ["maternity", "Maternity"], ["paternity", "Paternity"], ["study", "Study"],
        ]},
        { k: "start_date", label: "Start", type: "date", required: true },
        { k: "end_date", label: "End", type: "date", required: true },
        { k: "reason", label: "Reason", textarea: true },
      ]}
      testId="leave"
      emptyText="No leave requests."
    />
  );
}
